export class Mutations {
    public static readonly SetOrders: string = 'setOrders';
    public static readonly SetPage: string = 'setPage';
    public static readonly SetPageSize: string = 'setPageSize';
    public static readonly SetTotalPages: string = 'setTotalPages';
    public static readonly SetTotalOrders: string = 'setTotal';
    public static readonly SetFilterStatus: string = 'setFilterStatus';
    public static readonly SetFrom: string = 'setFrom';
    public static readonly SetTo: string = 'setTo';
}
